import ImageSelectCropper from '../../../shared/imageSelectCropper/ImageSelectCropper.vue'

export default {
  name: 'AvatarSelect',
  components: { ImageSelectCropper },
  props: {
    idImage: {
      type: String,
      default: ''
    }
  },
  methods: {
    onChangeImage(args) {
      this.$emit('changeImage', args)
    },
    onRemoveImage(args) {
      this.$emit('removeImage', args)
    }
  }
}
